import { render, staticRenderFns } from "./HeatVsAcPopUp.vue?vue&type=template&id=634e0f1c&"
import script from "./HeatVsAcPopUp.vue?vue&type=script&lang=js&"
export * from "./HeatVsAcPopUp.vue?vue&type=script&lang=js&"
import style0 from "./HeatVsAcPopUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeatVsAcPopUp.vue"
export default component.exports